import { ReportType, type ReportTypeValue } from "@pages/Templates/constants";

// Sentinel used by the Organization selector to represent the "no organization"
// (Global) option. Mapped to organization_id: null on submit; mapped from
// organization === null when prefilling. Never sent to the API.
export const GLOBAL_ORG_SENTINEL = "__global__";
export const GLOBAL_ORG_LABEL = "Global";

export const REPORT_TYPE_OPTIONS: ReportTypeValue[] = [
  ReportType.INITIAL_ASSESSMENT,
  ReportType.REASSESSMENT,
  ReportType.DIAGNOSIS_EVALUATION,
];

// No semantic Mosaic token for category hues; uses Mosaic's blue/yellow/orange scales.
export const REPORT_TYPE_CHIP_CLASSES: Record<ReportTypeValue, string> = {
  [ReportType.INITIAL_ASSESSMENT]: "border-yellow-300 bg-yellow-100 text-yellow-800",
  [ReportType.REASSESSMENT]: "border-orange-300 bg-orange-100 text-orange-800",
  [ReportType.DIAGNOSIS_EVALUATION]: "border-blue-300 bg-blue-100 text-blue-800",
};
